import AspUni1 from '@resources/competition/asp-uni-1.jpg?format=webp&quality=80&imagetools';
import AspUni2 from '@resources/competition/asp-uni-2.jpg?format=webp&quality=80&imagetools';
import AspUni3 from '@resources/competition/asp-uni-3.jpg?format=webp&quality=80&imagetools';
import AspUni4 from '@resources/competition/asp-uni-4.jpg?format=webp&quality=80&imagetools';
import AspUni5 from '@resources/competition/asp-uni-5.jpg?format=webp&quality=80&imagetools';
import AspUni6 from '@resources/competition/asp-uni-6.jpg?format=webp&quality=80&imagetools';
import AspUni7 from '@resources/competition/asp-uni-7.jpg?format=webp&quality=80&imagetools';
import AspUni8 from '@resources/competition/asp-uni-8.jpg?format=webp&quality=80&imagetools';
import AspUni9 from '@resources/competition/asp-uni-9.jpg?format=webp&quality=80&imagetools';
import FsLightbox from 'fslightbox-react';
import { useState } from 'react';

export const CompetitionGallery = () => {

    const IMAGES = [
        AspUni1, AspUni2, AspUni3,
        AspUni4, AspUni5, AspUni6,
        AspUni7, AspUni8, AspUni9,
    ]

    const LIGHTBOX_IMAGES = IMAGES.map((src, i) => (
        <img
            key={i}
            src={src}
            alt={`Zdjęcie ASP & UNIDEVELOPMENT - ${i + 1}`}
            width={1920}
            height={1080}
            className="w-full h-auto object-contain"
        />
    ))

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    });

    const openLightboxOnSlide = (index: number) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: index + 1,
        });
    };

    const hideHeader = () => {
        document.querySelector('.sticky.top-0.z-50.w-full')?.classList.add('hidden');
    };

    const showHeader = () => {
        document.querySelector('.sticky.top-0.z-50.w-full')?.classList.remove('hidden');
    };

    return (
        <section className="pt-12 lg:pb-28 pb-12 lg:px-20 px-4">
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-x-3 gap-y-6">
                {IMAGES.map((src, index) => (
                    <div key={index} className="cursor-pointer" onClick={() => openLightboxOnSlide(index)}>
                        <img
                            src={src}
                            alt={`Zdjęcie ASP & UNIDEVELOPMENT - ${index + 1}`}
                            className="aspect-square h-auto w-full object-cover"
                        />
                    </div>
                ))}
            </div>
            <FsLightbox
                toggler={lightboxController.toggler}
                sources={LIGHTBOX_IMAGES}
                slide={lightboxController.slide}
                onShow={hideHeader}
                onInit={hideHeader}
                onClose={showHeader}
            />
        </section>
    )
}